import { Data } from "../../types/Data";
import { State } from "../../types/State";

export function getLabelMore({
  state,
  data,
  defaultLabel,
}: {
  state: State;
  data: Data;
  defaultLabel: string;
}) {
  if (
    state["nb-piece"] ||
    state["nb-chambre"] ||
    state["annexes"] ||
    state["accessibilite"] ||
    state["type-chauffage"] ||
    state["dpe"]
  ) {
    return [
      ...(state["nb-piece"]?.map(
        (value) => data["nb-piece"][value]?.label || value
      ) || []),
      ...(state["nb-chambre"]?.map(
        (value) => data["nb-chambre"][value]?.label || value
      ) || []),
      ...(state["annexes"]?.map(
        (value) => data["annexes"][value]?.label || value
      ) || []),
      ...(state["accessibilite"]?.map(
        (value) => data["accessibilite"][value]?.label || value
      ) || []),
      ...(state["type-chauffage"]?.map(
        (value) => data["type-chauffage"][value]?.label || value
      ) || []),
      ...(state["dpe"]
        ? [
            `DPE : ${state["dpe"]
              .map((value) => data["dpe"][value]?.label[0] || value)
              .join(", ")}`,
          ]
        : []),
    ].join(", ");
  } else return defaultLabel;
}
